export default {
  "en": {
    "timestamp": {
      "labels": {
        "accepted": "Accepted {date}",
        "due": "Due {date}",
        "in": "In {time}",
        "justNow": "Just now",
        "noDeadline": "No deadline set",
        "starts": "Starts {date}",
        "today": "Today",
        "tomorrow": "Tomorrow",
        "uploaded": "Uploaded {date}",
        "yesterday": "Yesterday"
      }
    }
  }
}